<template>
    <el-drawer :title="$t('text.Set_shortcut_bar_menu')" :visible.sync="drawerVisible" direction="rtl" size="600px" :wrapperClosable="false" @close="close">
        <section class="section">
            <div class="selectBar">
                <!-- 左侧树 -->
                <section class="left_menu">
                    <p>{{ $t('text.Left_menu_bar') }}</p>
                    <div class="tree-wrap">
                        <el-tree
                            ref="tree"
                            :data="treedata"
                            :props="defaultProps"
                            node-key="id"
                            show-checkbox
                            :default-checked-keys="defaultCheckedKeys"
                            :render-content="renderContent"
                            @check="selectChange"
                            class="ztree"
                        ></el-tree>
                    </div>
                </section>
                <section class="center_menu">
                    <i class="el-icon-sort" @click="changeData"></i>
                </section>

                <!-- 右侧图标菜单 -->
                <section class="right_menu">
                    <p>{{ $t('text.Shortcut_bar') }}</p>
                    <div class="right-list">
                        <el-tooltip class="item" effect="dark" :content="generateTitle(opt)" placement="left-start" v-for="(opt, index) in right_arr" :key="index">
                            <span
                                @dragstart="drag($event, opt)"
                                @dragend="handleDragEnd($event, opt)"
                                @dragover.prevent="handleDragOver($event, opt)"
                                @dragenter="handleDragEnter($event, opt)"
                                draggable="true"
                            >
                                <span class="close" @click="iconClose(opt, index)">x</span>
                                <i :class="opt.icon"></i>
                            </span>
                        </el-tooltip>
                    </div>
                </section>
            </div>
        </section>
        <div class="btn">
            <el-button type="primary" @click="pathAffirm">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </el-drawer>
</template>

<script>
import { getShortCut, addShortCut } from '@/api/modules/shortCut.js';
import { generateTitle } from '@/utils/i18n';

export default {
    props: ['scDialogShow', 'quickMenu'],

    data() {
        return {
            treedata: [],
            defaultProps: {
                label: 'name',
                children: 'sub'
            },
            defaultCheckedKeys: [],
            right_arr: null
        };
    },
    computed: {
        drawerVisible: {
            get() {
                return this.scDialogShow;
            },
            set(val) {
                this.$emit('update:scDialogShow', val);
            }
        }
    },
    mounted() {
        this.right_arr = this.quickMenu ? [...this.quickMenu] : [];
        this.initLeftTree();
    },
    methods: {
        generateTitle,
        // 左侧菜单：与系统侧边栏一致（使用 CURRENT_SYSTEM_MENU）
        initLeftTree() {
            // 数据源与系统侧边栏一致，确保节点和名称完全相同
            const menu = this.$store.state.CURRENT_SYSTEM_MENU || [];
            this.treedata = menu;

            // 默认选中：用当前已选快捷菜单（right_arr）的 id
            const defkey = (this.right_arr || []).map(item => item.id);
            this.defaultCheckedKeys = defkey;
            this.$nextTick(() => {
                if (this.$refs.tree) {
                    this.$refs.tree.setCheckedKeys(defkey);
                }
            });
        },
        selectChange(data, info) {
            const status = info.checkedKeys.indexOf(data.id) !== -1;
            // 选中
            if (status) {
                if (data.sub && data.sub.length) {
                    // 需要一个个判断sub中的每一项内容是否都在已选列表内
                    const filted = data.sub.filter(item => {
                        // 保证都不在right_arr内
                        return this.right_arr.every(right => right.id !== item.id);
                    });
                    this.right_arr = this.right_arr.concat(filted);
                } else {
                    this.right_arr.push(data);
                }
            } else {
                // 取消选择的状态  此时 就需要在右侧列表中找出节点并将其删除

                const sub = data.sub ? data.sub.map(item => item.id) : null;
                this.right_arr = this.right_arr.filter(item => {
                    // 有子菜单
                    if (data.sub) {
                        // 子菜单里面的内容都要从数组中去除
                        return sub.indexOf(item.id) === -1;
                    } else {
                        // 无子菜单
                        if (item.id === data.id) return false;
                        else return true;
                    }
                });
            }

            //实现左右选择
            this.defaultCheckedKeys = this.right_arr.map(opt => {
                return opt.id;
            });
        },
        changeData() {
            //实现左右选择
            this.defaultCheckedKeys = this.right_arr.map(opt => {
                return opt.id;
            });
        },
        drag(ev, item) {
            // 克隆被拖拽元素
            this.dom = item;
        },
        handleDragEnd(ev) {
            this.dom = null;
        },
        //首先把div变成可以放置的元素，即重写dragenter/dragover
        handleDragOver(e) {
            e.dataTransfer.dropEffect = 'move';
        },
        handleDragEnter(e, item) {
            e.dataTransfer.effectAllowed = 'move';
            if (item === this.dom) {
                return;
            }
            const newItems = [...this.right_arr];
            const src = newItems.indexOf(this.dom);
            const dst = newItems.indexOf(item);

            newItems.splice(dst, 0, ...newItems.splice(src, 1));

            this.right_arr = newItems;
        },
        iconClose(opt, i) {
            this.defaultCheckedKeys.forEach((item, index) => {
                if (item === opt.id) {
                    this.defaultCheckedKeys.splice(index, 1);
                }
            });
            this.$nextTick(() => {
                this.$refs.tree.setCheckedKeys(this.defaultCheckedKeys);
            });
            //以防万一  下面这句也加上
            this.right_arr.splice(i, 1);
        },
        pathAffirm() {
            const arr = this.right_arr.map(item => {
                return item.id;
            });
            addShortCut(arr).then(({ result, state }) => {
                if (result === 200) {
                    this.$message({ message: this.$t('integration.set_successfully'), type: 'success' });
                    this.$emit('update:quickMenu', this.right_arr);

                    this.close();
                }
            });
        },
        close() {
            this.$emit('update:scDialogShow', false);
        },
        // 树节点渲染：与系统侧边栏一致，使用 generateTitle 显示国际化名称
        renderContent(h, { node, data, store }) {
            const title = this.generateTitle(data);
            const iconClass = data.icon || 'el-icon-menu';
            return (
                <div class="custom-tree-node" style="width:100%;padding-right:15px">
                    <i class={iconClass} style="margin-right:5px"></i>
                    <span>{title}</span>
                </div>
            )
        }
    }
};
</script>

<style lang="scss" scoped>
.section {
    width: 100%;
    height: calc(100% - 60px);
    padding: 0 20px;
    box-sizing: border-box;
}
.selectBar {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    .left_menu {
        flex: 1;
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        p {
            height: 24px;
            line-height: 24px;
            font-size: 16px;
            text-align: center;
            color: var(--primary-color);
            border: 1px solid #eee;
            box-sizing: border-box;
        }
        .tree-wrap {
            flex: 1;
            overflow: auto;
        }
    }
    .center_menu,
    .right_menu {
        width: 100px;
        height: 100%;
        p {
            height: 24px;
            line-height: 24px;
            font-size: 16px;
            text-align: center;
            color: var(--primary-color);
            box-sizing: border-box;
            border-bottom: 1px solid #eee;
        }
    }
    .center_menu {
        width: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
            color: #000000;
            font-size: 28px;
            cursor: pointer;
            transform: rotate(90deg);
        }
    }
    .right_menu {
        border: 1px solid #eee;
        text-align: center;
        display: flex;
        flex-direction: column;
        .right-list {
            flex: 1;
            overflow: auto;
        }
        span {
            margin: 0 auto;
            width: 50px;
            height: 50px;
            display: block;
            margin-top: 10px;
            text-align: center;
            position: relative;
        }
        i {
            display: block;
            color: var(--primary-color);
            font-size: 36px;
            cursor: pointer;
            line-height: 50px;
        }
        .close {
            position: absolute;
            top: -5px;
            right: 0px;
            width: 14px;
            height: 14px;
            display: inline-block;
            border-radius: 50%;
            color: var(--primary-color);
            font-size: 14px;
            cursor: pointer;
        }
        .close:hover {
            color: red;
        }
    }
}
.btn {
    width: 100%;
    text-align: center;
    padding: 15px 0;
}
</style>
